import EmblaCarousel from 'embla-carousel';
const selectors = {
    featuredArticlesCarousel: '[data-featured-articles-carousel]',
    featuredArticlesCarouselViewport: '[data-featured-articles-carousel-viewport]',
    featuredArticlesCarouselPrev: '[data-featured-articles-carousel-prev]',
    featuredArticlesCarouselNext: '[data-featured-articles-carousel-next]',
};
const featuredArticlesCarousel = () => {
    const featuredArticlesCarousels = document.querySelectorAll(selectors.featuredArticlesCarousel);
    if (featuredArticlesCarousels) {
        featuredArticlesCarousels.forEach((carousel) => {
            const viewportNode = carousel.querySelector(selectors.featuredArticlesCarouselViewport);
            const prevButtonNode = carousel.querySelector(selectors.featuredArticlesCarouselPrev);
            const nextButtonNode = carousel.querySelector(selectors.featuredArticlesCarouselNext);
            const options = {
                loop: true,
                align: 'start',
            };
            const embla = EmblaCarousel(viewportNode, options);
            prevButtonNode.addEventListener('click', () => embla.scrollPrev(), false);
            nextButtonNode.addEventListener('click', () => embla.scrollNext(), false);
        });
    }
};
export { featuredArticlesCarousel };
